/**
 * 第三方接口，在headers加入属性 X-THIRD-PARTY: true
 */
import axios from 'axios'
import store from '@/store'
import router from '@/router/router'
import { serialize, getExportFileName } from '@/util/util'
import { getToken } from '@/util/auth'
import { Message } from 'element-ui'
import website from '@/config/website'
import NProgress from 'nprogress' // progress bar
import { saveAs } from 'file-saver'
import 'nprogress/nprogress.css'
import env from '@/config/env' // progress bar style
import { handleRequestHeader } from './interceptors.request'
import qs from 'qs'
import responseDecode from './middle-ware/response.decode'

// const url = window.location.href
// const urlArr = url.split('/')
// let meituan = urlArr.indexOf('meituan')
// let baseURL = meituan>-1?'http://192.168.31.250:8715':env.baseURL
// console.log(baseURL)
const http = axios.create({
  baseURL: env.baseURL,
  timeout: 10000,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    Version: 'test'
  }
})
// 返回其他状态吗
http.validateStatus = function (status) {
  return status >= 200 && status <= 500 // 默认的
}

function boldFun(url) {
  // 不需要连开发本地环境是打开
  return false
  // const set = new Set([
  //     '/advertising/banner/changeStatus',
  //     '/advertising/banner/edit',
  //     '/advertising/banner/page'
  // ])
  // return set.has(url)
}

// NProgress Configuration
NProgress.configure({
  showSpinner: false
})
// HTTPrequest拦截
http.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      ...handleRequestHeader()
    }
    NProgress.start()
    const meta = config.meta || {}
    const isToken = meta.isToken === false
    const flag = process.env.NODE_ENV === 'development' && boldFun(config.url)
    if (getToken() && !isToken && !flag) {
      config.headers.Authorization = 'bearer ' + getToken() // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
    }
    // headers中配置serialize为true开启序列化
    if (config.method === 'post' && meta.isSerialize === true) {
      config.data = serialize(config.data)
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
// 添加内容解密拦截器
http.interceptors.response.use(responseDecode)
// HTTPresponse拦截
http.interceptors.response.use(
  (res) => {
    NProgress.done()
    const statusCode = res.status || 200
    const statusWhiteList = website.statusWhiteList || []
    const message = res.data.msg || res.data.userMsg || '未知错误，请重试'
    const thirdParty = res.config.headers['X-THIRD-PARTY']
    if (statusCode === 200 && thirdParty) {
      return res.data
    }
    if (statusCode !== 200) {
      Message({
        message,
        type: 'error'
      })
      // return Promise.reject(new Error(message))
      return res.data
    }
    // 如果在白名单里则自行catch逻辑处理
    if (statusWhiteList.includes(statusCode)) {
      return Promise.reject(res)
    }
    if (res.data.code !== undefined && res.data.code !== 0) {
      Message({
        message,
        type: 'error'
      })
      return res.data
    }
    if (res.request && res.request.responseType === 'blob') {
      return res
    }
    return res.data
  },
  (error) => {
    NProgress.done()
    const errorCode = error.request && error.request.status
    const errorResq = error.response && error.response.data ? error.response.data : {}
    // 收集错误日志
    store.dispatch('addErrorLogs', {
      message: '请求出错了',
      stack: error.response || error.config || error
    })
    // 如果是401则跳转到登录页面
    if (errorCode === 401) {
      store.dispatch('FedLogOut').then(() => router.push({ path: '/login' }))
      return errorResq
    }
    if (errorCode === 500 && errorResq.code === 1) {
      Message({
        message: errorResq.userMsg || errorResq.msg || '服务器出错了，请重试',
        type: 'error'
      })
      return errorResq
    }
    Message({
      message: errorResq.userMsg || errorResq.msg || '服务器出错了，请重试',
      type: 'error'
    })
    // Promise.resolve(errorResq);
    return errorResq
  }
)

/**
 *
 * @param {*} url
 * @param {*} params
 * @param {*} filename 文件名，需要文件类型后缀
 * @returns
 *
 * const reqUrl = env.ferryUrl + '/complaint-suggestion/export'
 * download(reqUrl, param, 'test.xlsx')
 *
 */
export function download(url, params, filename) {
  const reqUrl = url + '?' + qs.stringify(params)
  return http
    .get(reqUrl, {
      headers: { 'Content-Type': 'application/vnd.ms-excel' },
      responseType: 'blob'
    })
    .then(async (resp) => {
      if (resp.code && resp.code !== 0) {
        return
      }
      const blob = new Blob([resp])
      saveAs(blob, filename)
    })
}

export function exportExcelPost(url, params, filename) {
  return http.post(url, params, { responseType: 'blob' }).then((res) => {
    const link = document.createElement('a')
    const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
    const excelName = getExportFileName(res, filename)
    link.style.display = 'none'
    link.href = URL.createObjectURL(blob)
    link.download = excelName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  })
}

export default http
